import {
  createExtensionBlueprint,
  createExtensionDataRef,
} from '@backstage/frontend-plugin-api';
import type { AppTypeModule } from './appTypeModule';

/** Le module porté par une extension `app-type-module`. */
export const appTypeModuleDataRef =
  createExtensionDataRef<AppTypeModule>().with({
    id: 'waadoo.app-type-module',
  });

/**
 * Un module de type d'application (`appTypeModule.ts`), rattaché au
 * registre `api:app/app-type-modules` (`appTypeModulesApi.ts`) : une
 * extension `app-type-module:app/<nom>` par type. Comme IconBundleBlueprint,
 * dont il reprend la forme : le registre lit les modules attachés à son
 * entrée `modules`, dans l'ordre de l'arbre de l'application.
 */
export const AppTypeModuleBlueprint = createExtensionBlueprint({
  kind: 'app-type-module',
  attachTo: { id: 'api:app/app-type-modules', input: 'modules' },
  output: [appTypeModuleDataRef],
  factory: (params: { module: AppTypeModule }) => [
    appTypeModuleDataRef(params.module),
  ],
  dataRefs: { module: appTypeModuleDataRef },
});
